import { Languages } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";

export default function LanguageSwitcher({ className }: { className?: string }) {
  const { lang, toggleLang } = useLanguage();
  return (
    <button
      onClick={toggleLang}
      aria-label={lang === "he" ? "العربية" : "עברית"}
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border border-border/60 bg-background/50 text-foreground/80 hover:text-primary hover:border-primary hover:bg-primary/10 transition-all",
        className
      )}
    >
      <Languages className="h-4 w-4" />
      <span>{lang === "he" ? "العربية" : "עברית"}</span>
    </button>
  );
}
